<template>
  <div>
    <div>
      <span>验证码已发送至手机：</span>
      <span class="main-color">{{ telphone }}</span>
    </div>

    <div>
      <reg-input
        :value.sync="validCode"
        placeholder="输入验证码"
        ref="validCode"
      >
        <template #button>
          <a
            @click="getSmsValidCode()"
            class="valid-img main-color"
          >{{ smsCodeTips }}</a>
        </template>
      </reg-input>
    </div>

    <ld-button
      :loading="submiting"
      :disabled="!validSuccess"
      class="submit-btn"
      @click.native="submit"
      main2
      size="lg"
    >
      {{ $t('B005','下一步') }}
    </ld-button>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import ldButton from 'Common/ldButton'
import regInput from 'Views/User/Register/reg-input'
import { validators } from 'Utils/valid'
import { ifStrBlank } from 'Utils/string'

export default {
  components: {
    regInput,
    ldButton,
  },
  data() {
    return {
      validators,
      submiting: false,
      validCode: '',
      smsCodeTips: '获取验证码',
    }
  },
  created() {
    this.$store.commit('ResetPassword/SET_STEP', 2)
    this.time()
  },
  methods: {
    async submit() {
      let valider = validators['is-string'](this.telphone, '验证码')
      if (!valider.valid) {
        this.$validErrorTips(valider.msg)
        return
      }

      this.submiting = true
      try {
        let res = await this.$api['user/smsCodeCheck']({
          phoneNumber: this.telphone,
          smsCode: this.validCode
        })

        if (res.data.checkResult == 0) {
          this.$dialog({ message: res.data.cause })
        }
        if (res.data.checkResult == 1) {
          this.$store.commit('ResetPassword/SET_VALIDCODE', this.validCode)
          this.$router.push('/resetPassword/thirdStep')
        }
      } finally {
        this.submiting = false
      }
    },
    // 获取短信验证码
    getSmsValidCode() {
      if (this.smsCodeTips !== '重新发送') return false

      this.time()
      this.$api['user/smsCodeGet']({
        compId: this.loginConfig.compaySuper,
        phoneNumber: this.telphone,
        type: '找回密码'
      })
    },
    time() {
      // 倒计时 60s
      let threshold = 60,
        count = 0
      let time = setInterval(() => {
        let diff = threshold - count
        count++
        this.smsCodeTips = `${diff} S`
        if (diff === 0) {
          clearInterval(time)
          this.smsCodeTips = '重新发送'
        }
      }, 1000)
    }
  },
  computed: {
    ...mapGetters(['loginConfig']),
    ...mapState('ResetPassword', {
      telphone: state => state.telphone
    }),
    validSuccess: function() {
      return !ifStrBlank(this.validCode)
    }
  }
}
</script>


